import React, { useState, useEffect } from "react"; // useRef
import { Button, Grid, Form, Modal, Icon, Label, Checkbox, Dropdown } from "semantic-ui-react"; // Image
import PropTypes from "prop-types";
import { isEmpty, isEqual, isNumber, filter, includes, get, reject, map, split, trim } from "lodash";
import Joi from "joi";
import moment from "moment";

// redux
import { connect } from "react-redux";

// Modals
import ConfirmModal from "@Modals/ConfirmModal";
import genericAction from "@Actions/generic";
// Utils
import { dropdownFormat } from "@Utils/formats";
import { getExcludingNulls } from "@Utils/index";
import { orderWeek } from "@Utils/orders";

// Components
import Input from "@Components/Input";
import InputTextArea from "@Components/TextArea";
import ColorPicker from "@Components/ColorPicker";
import NewTable from "@Components/NewTable";
import ChanelCrud from "@Features/CompanyMaster/Modals/ChanelCrud";
import SystemLogFieldCrud from "@Features/CompanyMaster/Modals/SystemLogFieldCrud";
import AlertTimes from "@Features/CompanyMaster/Modals/AlertTimes";
import HoursDays from "@Components/HoursDays";
// import { defaultImage } from "@Assets/index";
// import { compressImage } from "@Utils/functionality";
// import { stateSetter, getExcludingNulls } from "@Utils";
import FileManager from "@Components/FileManager";
import AddHoliDay from "./AddHoliDay";
// Styles
import styles from "./styles.module.css";

// staticData
import alertTimesData from "./staticData";

// const survey = [];

const SettingCrud = ({ modalCrud, tableValue, onClose, refresh, dispatch, currentCompanyId }) => {
	// Hooks
	const [data, setData] = useState([]);
	// const [fileImage, setFileImage] = useState("");
	const [stateHeader, setStateHeader] = useState("infobasic");
	// formData
	// const [modalOption, setModalOption] = useState("");

	const [errors, setErrors] = useState([{ name: "", userLimit: "", sessionTimeout: "", domainErr: "", suggestQA: "" }]);

	// modals hooks
	// -alertTimes
	const [alertItem, setAlertItem] = useState([]);
	const [openAlertTimes, setOpenAlertTimes] = useState(false);
	const [modalOption, setModalOption] = useState("");

	// -ChanelCrud
	const [channelTableData, setChannelTableData] = useState([]);
	const [channelData, setChannelData] = useState([]);
	const [openChanelCrud, setOpenChanelCrud] = useState(false);
	const [openChannelDConfirm, setOpenChannelDConfirm] = useState(false);

	// -systemLogFielCrud
	const [systemLogFieldData, setSystemLogFieldData] = useState([]);
	const [openSystemLogFieldCrud, setOpenSystemLogFieldCrud] = useState(false);
	const [openConfirmModalCompanyFields, setOpenConfirmModalCompanyFields] = useState(false);
	const [openDeleteCompanyFields, setOpenDeleteCompanyFields] = useState({});

	// -presetMessages
	const [presetMessages, setPresetMessages] = useState([]);
	const [predWelcomeData, setPredWelcomeData] = useState([]);
	const [predBeginData, setPredBeginData] = useState([]);
	const [predCloseData, setPredCloseData] = useState([]);
	const [predTimeOutData, setPredTimeOutData] = useState([]);
	// const [surveyData, setSurveyData] = useState([]);
	const [nameCompany, setNameCompany] = useState("");
	const [state, setState] = useState(true);
	const [companyFieldsD, setCompanyFieldsD] = useState([]);
	const [openCancelConfirm, setOpenCancelConfirm] = useState(false);
	const [schedules, setSchedules] = useState([]);
	const [alwaysOpen, setAlwaysOpen] = useState(false);
	const [isHours, setIsHours] = useState(true);
	const [schedulesFeriados, setSchedulesFeriados] = useState([]);
	const [openAddHoliDay, setOpenAddHoliDay] = useState(false);
	const [itemEditHoliDay, setItemEditHoliDay] = useState({});
	const [holidayToDelete, setHolidayToDelete] = useState([]);
	const [copied, setCopied] = useState(false);
	const [copiedPin, setCopiedPin] = useState(false);
	const [copiedLogin, setCopiedLogin] = useState(false);
	const [openCleanChats, setOpenCleanChats] = useState(false);
	const [openCleanChatsh, setOpenCleanChatsh] = useState(false);

	const defaultColors = {
		text: "#ffffff",
		panel: "#c9cbe4",
		accent: "#2d3259",
		header: "#191e3e",
		toggle: "#7ed321",
		buttons: "#c9cbe4",
		primary: "#191e3e",
		groupBack: "#c9cbe4",
		panelText: "",
		fontsHover: "#ffffff",
		groupFonts: "#000000",
		panelModal: "#c9cbe4",
		fontsHeader: "#ffffff",
		groupHeader: "#090909",
		toggleFalse: "#ff0000",
		accentDarker: "#2d3259",
		fontsButtons: "#2d3259",
		fontFormulary: "#ffffff",
		buttonFormulary: "#2d3259",
		headerFormulary: "#9b9b9b",
		hoverButtonsFormulary: "#c9cbe4",
	};

	const [colors, setColors] = useState(defaultColors);
	// const [headerColors, setHeaderColors] = useState({
	// 	header: "",
	// 	text: "",
	// });
	const [userLimit, setUserLimit] = useState("");
	// const [defaultGroup, setDefaultGroup] = useState("");
	const [sessionTimeout, setSessionTimeout] = useState("");
	const [clientTime, setClientTime] = useState("");
	// const [assignChats, setAssignChats] = useState(false);
	const [tagOnClose, setTagOnClose] = useState(false);
	const [applyConsent, setApplyConsent] = useState(false);
	const [sendFlow, setSendFlow] = useState(false);
	const [isPromo, setIsPromo] = useState(false);
	const [endChatNoResponse, setEndChatNoResponse] = useState(false);
	const [canLogoutWithAssignedChats, setCanLogoutWithAssignedChats] = useState(false);
	const [isBlocked, setIsBlocked] = useState(false);
	const [suggestQA, setSuggestQA] = useState("");
	// const [welcomeMessageId, setWelcomeMessageId] = useState("");
	const [typeAsignation, setTypeAsignation] = useState("");
	// const [startMessageId, setStartMessageId] = useState("");
	// const [closeMessageId, setCloseMessageId] = useState("");
	// const [outOfScheduleMessageId, setOutOfScheduleMessageId] = useState("");
	// const [surveyId, setSurveyId] = useState("");
	const [pin, setPin] = useState("");
	const [alerts, setAlerts] = useState([]);
	const [initialFormData, setInitialFormData] = useState({});
	const [id, setId] = useState("");
	// const [logo, setLogo] = useState("");
	const [companyLink, setCompanyLink] = useState("");
	const [loginLink, setLoginLink] = useState("");
	const [isDomain, setIsDomain] = useState("");
	const [links, setLinks] = useState([]);
	const [images, setImages] = useState([]);
	const [imagesD, setImagesD] = useState([]);
	const [alertsToDelete, setAlertsToDelete] = useState({});
	const [openAlertsDelete, setOpenAlertsDelete] = useState(false);
	const [clientExpiredTime, setClientExpiredTime] = useState("");

	// Times
	const [botWarning, setBotWarning] = useState("");
	const [botTimeout, setBotTimeout] = useState("");
	const [closingKeywords, setClosingKeywords] = useState("");
	const [blackListKeyWords, setBlackListKeyWords] = useState("");
	const [promoList, setPromoList] = useState("");
	const [flowKeywords, setFlowKeywords] = useState("");
	const [tagList, setTagList] = useState("");
	const [formData, setFormData] = useState({
		name: "",
		logo: null,
		state: true,
		channels: [],
		groups: [],
		companyFields: [],
		headerColors: {
			header: "",
			text: "",
		},
		domain: "",
		userLimit: "",
		defaultGroup: "",
		sessionTimeout: "",
		clientTime: "",
		assignChats: false,
		tagOnClose: false,
		isBlocked: false,
		sendFlow: false,
		suggestQA: "",
		clientExpiredTime: "",
		fixedFields: [
			{ label: "name", isEditable: false, isRequired: false },
			{ label: "phone", isEditable: false, isRequired: false },
			{ label: "email", isEditable: false, isRequired: false },
		],
		endChatNoResponse: false,
		canLogoutWithAssignedChats: false,
		welcomeMessageId: [],
		typeAsignation: "",
		startMessageId: [],
		closeMessageId: [],
		outOfScheduleMessageId: [],
		surveyId: "",
		pin: "",
		/* 	alerts: alerts, */
	});

	// const fileInputRef = useRef(null);

	// Pin handler
	const [showPin, setShowPin] = useState(false);

	useEffect(() => {
		(async () => {
			setModalOption(modalCrud);
			if (modalCrud !== "Add") {
				const presetMessagesPromise = dispatch(genericAction({ method: "get", route: "presetMessages/all" }));
				const companyDataPromise = dispatch(genericAction({ method: "get", route: `company/${currentCompanyId}` }));

				const [companyDataResponse, presetMessagesResponse] = await Promise.all([companyDataPromise, presetMessagesPromise]);
				setData(companyDataResponse);

				setNameCompany(companyDataResponse.name);
				setPin(companyDataResponse.pin);
				setIsDomain(companyDataResponse.domain);
				setChannelData(companyDataResponse.channels);
				// setCompanyFields(companyDataResponse.companyFields);
				setId(companyDataResponse.id);
				const logo = get(companyDataResponse, "logo", []);
				setImages(logo ? [logo] : []);
				// formatted schedules
				let shecdulesFormatted = get(companyDataResponse, "schedule", []);

				if (!isEmpty(companyDataResponse.schedule)) {
					shecdulesFormatted = map(companyDataResponse.schedule, (item) => {
						return {
							...item,
							days: getExcludingNulls(item, "day", ""),
							beginTime: getExcludingNulls(item, "startHour", "").slice(0, 5) || "",
							endTime: getExcludingNulls(item, "endHour", "").slice(0, 5) || "",
						};
					});
				}
				setSchedules(shecdulesFormatted);
				setSchedulesFeriados(companyDataResponse.holidays);

				// settings
				setUserLimit(companyDataResponse.settings.userLimit);
				setSessionTimeout(companyDataResponse.settings.sessionTimeout);
				setClientTime(companyDataResponse.settings.autoCloseChatInHrs ?? "");
				setTagOnClose(companyDataResponse.settings.tagOnClose);
				setApplyConsent(companyDataResponse.settings.applyConsent);
				setEndChatNoResponse(companyDataResponse.settings.endChatNoResponse);
				setCanLogoutWithAssignedChats(companyDataResponse.settings.canLogoutWithAssignedChats);
				setTypeAsignation(companyDataResponse.settings.typeAsignation);
				setBotWarning(companyDataResponse.settings.botWarning);
				setBotTimeout(companyDataResponse.settings.botTimeout);
				setIsBlocked(companyDataResponse.settings.isBlocked);
				setSendFlow(companyDataResponse.settings.sendFlow);
				setIsPromo(companyDataResponse.settings.isPromo);
				setSuggestQA(companyDataResponse.settings.suggestQA || "");
				setClientExpiredTime(companyDataResponse.settings.clientExpiredTime || "");
				setClosingKeywords(
					Array.isArray(companyDataResponse.settings.closingKeywords)
						? companyDataResponse.settings.closingKeywords.join(", ")
						: companyDataResponse.settings.closingKeywords || ""
				);
				const setting = companyDataResponse.settings;
				setClosingKeywords(
					get(setting, "closingKeywords", []) && !isEmpty(get(setting, "closingKeywords", []))
						? get(setting, "closingKeywords", []).toString()
						: ""
				);
				setBlackListKeyWords(
					get(setting, "blackListKeyWords", []) && !isEmpty(get(setting, "blackListKeyWords", []))
						? get(setting, "blackListKeyWords", []).toString()
						: ""
				);
				setPromoList(
					get(setting, "promoList", []) && !isEmpty(get(setting, "promoList", [])) ? get(setting, "promoList", []).toString() : ""
				);
				setFlowKeywords(
					get(setting, "flowKeywords", []) && !isEmpty(get(setting, "flowKeywords", [])) ? get(setting, "flowKeywords", []).toString() : ""
				);
				setTagList(get(setting, "tagList", []) && !isEmpty(get(setting, "tagList", [])) ? get(setting, "tagList", []).toString() : "");
				setColors({
					...defaultColors,
					...companyDataResponse.settings.colors,
				});

				setAlerts(!isEmpty(companyDataResponse.settings.alerts) ? companyDataResponse.settings.alerts : alertTimesData);
				setPresetMessages(presetMessagesResponse);
				if (!isEmpty(companyDataResponse)) {
					const newData = {
						companyId: companyDataResponse.id,
						name: companyDataResponse.name,
						logo: !isEmpty(images) ? [images[0]] : [],
						state: companyDataResponse.isActive,
						groups: companyDataResponse.groups,
						channels: companyDataResponse.channels,
						companyFields: get(companyDataResponse, "companyFields", []),
						holidays: companyDataResponse.holidays,
						schedule: companyDataResponse.schedule,
						domain: companyDataResponse.domain,

						// settings
						userLimit: companyDataResponse.settings.userLimit,
						typeAsignation: companyDataResponse.settings.typeAsignation,
						defaultGroup: companyDataResponse.settings.defaultGroup,
						sessionTimeout: companyDataResponse.settings.sessionTimeout,
						clientTime: companyDataResponse.settings.clientTime,
						assignChats: companyDataResponse.settings.assignChats,
						tagOnClose: companyDataResponse.settings.tagOnClose,
						applyConsent: companyDataResponse.settings.applyConsent,
						sendFlow: companyDataResponse.settings.sendFlow,
						endChatNoResponse: companyDataResponse.settings.endChatNoResponse,
						canLogoutWithAssignedChats: companyDataResponse.settings.canLogoutWithAssignedChats,
						isBlocked: companyDataResponse.settings.isBlocked,
						suggestQA: companyDataResponse.settings.suggestQA || "",
						clientExpiredTime: companyDataResponse.settings.clientExpiredTime || "",
						welcomeMessageId: companyDataResponse.settings.welcomeMessageId
							? Array.isArray(companyDataResponse.settings.welcomeMessageId)
								? companyDataResponse.settings.welcomeMessageId
								: [companyDataResponse.settings.welcomeMessageId]
							: [],
						startMessageId: companyDataResponse.settings.startMessageId
							? Array.isArray(companyDataResponse.settings.startMessageId)
								? companyDataResponse.settings.startMessageId
								: [companyDataResponse.settings.startMessageId]
							: [],
						closeMessageId: companyDataResponse.settings.closeMessageId
							? Array.isArray(companyDataResponse.settings.closeMessageId)
								? companyDataResponse.settings.closeMessageId
								: [companyDataResponse.settings.closeMessageId]
							: [],
						outOfScheduleMessageId: companyDataResponse.settings.outOfScheduleMessageId
							? Array.isArray(companyDataResponse.settings.outOfScheduleMessageId)
								? companyDataResponse.settings.outOfScheduleMessageId
								: [companyDataResponse.settings.outOfScheduleMessageId]
							: [],
						surveyId: companyDataResponse.settings.surveyId,
						alerts: companyDataResponse.settings.alerts,
						botWarning: companyDataResponse.settings.botWarning,
						botTimeout: companyDataResponse.settings.botTimeout,
						colors: get(companyDataResponse, "settings.colors", {}),
						fixedFields: (() => {
							const defaults = [
								{ label: "name", isEditable: false, isRequired: false },
								{ label: "phone", isEditable: false, isRequired: false },
								{ label: "email", isEditable: false, isRequired: false },
							];
							const saved = companyDataResponse.settings.fixedFields;
							if (!saved || !Array.isArray(saved)) return defaults;
							return defaults.map((d) => {
								return (
									saved.find((f) => {
										return f.label === d.label;
									}) || d
								);
							});
						})(),
					};
					setNameCompany(get(companyDataResponse, "name", ""));
					setState(companyDataResponse.isActive);
					// setFileImage(companyDataResponse.logo);
					setFormData(newData);
					setInitialFormData(newData);
					setChannelTableData(get(companyDataResponse, "channels", []));
					setAlwaysOpen(companyDataResponse.settings.alwaysOpen);
					dropdownData();
				}
			}
			if (modalCrud === "Add") {
				setAlerts(alertTimesData);
				const newData = {
					companyId: null,
					name: "",
					logo: [],
					state: true,
					groups: [],
					channels: [],
					companyFields: [],
					domain: "",
					// settings
					userLimit: "",
					sessionTimeout: "",
					clientTime: "",
					assignChats: true,
					tagOnClose: false,
					applyConsent: false,
					sendFlow: false,
					endChatNoResponse: false,
					canLogoutWithAssignedChats: false,
					isBlocked: false,
					suggestQA: "",
					clientExpiredTime: "",
					welcomeMessageId: null,
					startMessageId: null,
					closeMessageId: null,
					outOfScheduleMessageId: null,
					surveyId: null,
					colors: {},
					alerts: alertTimesData,
					fixedFields: [
						{ label: "name", isEditable: false, isRequired: false },
						{ label: "phone", isEditable: false, isRequired: false },
						{ label: "email", isEditable: false, isRequired: false },
					],
				};
				setFormData(newData);
			}
		})();
	}, []);

	useEffect(() => {
		if (modalOption !== "Add") {
			const currentToken = get(tableValue, "token", "");
			const currentCompanyName = get(tableValue, "name", "");

			if (!isEmpty(currentToken) && !isEmpty(currentCompanyName)) {
				let domains = isDomain || window.location.origin;
				if (!/^https?:\/\//i.test(domains)) {
					domains = `https://${domains}`;
				}

				const linkRegister = new URL(`${domains}/auth/register/${currentCompanyName}/${currentToken}`);
				const linkLogin = new URL(`${domains}/auth/login/${currentCompanyName}/${currentToken}`);

				setCompanyLink(linkRegister.href);
				setLoginLink(linkLogin.href);
			}
		}
	}, [isDomain, tableValue, modalOption]);

	useEffect(() => {
		if (!isEmpty(data)) {
			dropdownData();
		}
	}, [presetMessages]);

	// state handler
	const handleStateHeader = (states) => {
		setStateHeader(states);
	};

	// console.log(channelData, "channelData");

	// modals handler
	const channelsHandler = (item, options) => {
		let newChannels = channelTableData;

		switch (options) {
			case "Add":
				newChannels = [...channelTableData, item];
				break;

			case "Edit":
				newChannels = [
					...reject(newChannels, (current) => {
						return current.id === item.id;
					}),
					item,
				];
				break;

			default:
				break;
		}
		setChannelTableData(newChannels);
	};

	const channelDConfirmHandler = (ChData) => {
		dispatch(genericAction({ method: "delete", route: `companyChannels/${ChData.id}` }));
		setChannelTableData(
			reject(channelTableData, (item) => {
				return item.id === ChData.id;
			})
		);
		setOpenChannelDConfirm(false);
	};

	const dropdownData = () => {
		const filterMsjPredWelcome = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Bienvenida")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		const filterMsjPredBegin = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Inicio")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		const filterMsjPredClose = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Cierre")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		const filterMsjPredTimeOut = filter(presetMessages, (item) => {
			let valueFilter = false;
			if (includes(get(item, "type.name"), "Fuera de Horario")) {
				valueFilter = true;
			} else {
				valueFilter = false;
			}
			return valueFilter;
		});

		// const filterMsjPredSurvey = filter(survey, { isActive: true });

		// setSurveyData(dropdownFormat(filterMsjPredSurvey, "title", "surveyId"));
		setPredBeginData(dropdownFormat(filterMsjPredBegin, "title", "id"));
		setPredCloseData(dropdownFormat(filterMsjPredClose, "title", "id"));
		setPredTimeOutData(dropdownFormat(filterMsjPredTimeOut, "title", "id"));
		setPredWelcomeData(dropdownFormat(filterMsjPredWelcome, "title", "id"));
	};

	const schema = Joi.object().keys({
		name: Joi.string().min(4).messages({
			"string.min": "Nombre debe tener mínimo 4 caracteres",
			"string.empty": "Nombre es un campo requerido",
		}),

		userLimit: Joi.number().min(1).messages({
			"number.base": "Limite de usuarios es un campo requerido",
			"number.min": "Limite de usuarios debe ser mayor a 0",
		}),

		sessionTimeout: Joi.number().min(1).messages({
			"number.base": "Cerrar sesión inactiva es un campo requerido",
			"number.min": "Cerrar sesión inactiva debe ser mayor a 0",
		}),

		domainErr: Joi.string().required().messages({
			"string.empty": "Dominio es un campo requerido",
		}),

		typeAsignation: Joi.string().valid("Manual", "Balanced", "Round Robin").required().messages({
			"any.only": "Tipo de asignación debe ser Manual, Balanceado o Round Robin",
			"string.empty": "Tipo de asignación es un campo requerido",
		}),
		suggestQA: Joi.string().valid("Sugerir", "Múltiple", "Individual").required().messages({
			"any.only": "Resp. Rápida debe ser Sugerir, Múltiple o Individual",
			"string.empty": "Resp. Rápida es un campo requerido",
		}),
		images: Joi.array().min(1).messages({
			"array.min": "Debes subir al menos una imagen",
		}),
		isPromo: Joi.boolean(),
		promoList: Joi.when("isPromo", {
			is: true,
			then: Joi.string().required().messages({
				"string.empty": "Palabras Promo es requerido cuando Promo está activo",
			}),
			otherwise: Joi.string().allow(""),
		}),
		tagList: Joi.when("isPromo", {
			is: true,
			then: Joi.string().required().messages({
				"string.empty": "Etiquetas Promo es requerido cuando Promo está activo",
			}),
			otherwise: Joi.string().allow(""),
		}),
	});

	// Effect

	// input handlers
	// const inputHandler = (e, { name, value }) => {
	// 	const re = /^[0-9\b]+$/;
	// 	let values = value;
	// 	if (name === "userLimit" || name === "sessionTimeout") {
	// 		if (value === "" || re.test(value)) {
	// 			values = value;
	// 		} else {
	// 			values = formData[name];
	// 		}
	// 	}

	// 	setFormData({
	// 		...formData,
	// 		[name]: values,
	// 	});
	// };

	/**
	 * The `checkBoxHandler` function updates the `formData` state by toggling the value of a specific property based on the checkbox input's name
	 * and checked status.
	 */
	// const checkBoxHandler = (e, { name, checked }) => {
	// 	setFormData({
	// 		...formData,
	// 		[name]: checked,
	// 	});
	// };

	const dorpdownHandler = (e, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};

	const colorHandler = (name, value) => {
		let newValue = value;
		if (newValue.length === 6 && !newValue.startsWith("#")) {
			newValue = `#${newValue}`;
		}
		if (newValue.length <= 10) {
			setColors({ ...colors, [name]: newValue });
		}
	};

	const changePin = async () => {
		const newPin = await dispatch(genericAction({ method: "GET", route: `/companies/generatePin` }));
		if (!isEmpty(newPin)) {
			setPin(newPin);
		}
	};

	const channelHandlerTable = (name, item) => {
		switch (name) {
			case "Add":
				setChannelData({
					channel: {},
					saveOption: modalOption,
					companyId: data.id,
					companyName: nameCompany,
					modalOption: name,
				});
				setOpenChanelCrud(true);
				break;

			case "Edit":
			case "Watch":
				setChannelData({
					channel: item,
					modalOption: name,
					companyId: data.id,
					companyName: nameCompany,
				});
				setOpenChanelCrud(true);
				break;

			case "Eraser":
				setOpenChannelDConfirm(true);
				setChannelData({ label: item.label, id: item.id });
				break;

			default:
				break;
		}
	};

	const alertTimesHandler = (item) => {
		setFormData({
			...formData,
			alerts: [...reject(formData.alerts, { name: item.name }), item],
		});

		setAlerts([...reject(alerts, { name: item.name }), item]);
	};

	const systemLogFieldHandlerTable = (name, item) => {
		switch (name) {
			case "Add":
				setSystemLogFieldData({
					companyFields: formData.companyFields,
					systemLogField: {},
					modalOption: name,
				});
				setOpenSystemLogFieldCrud(true);
				break;

			case "Edit":
			case "Watch":
				setSystemLogFieldData({
					companyFields: formData.companyFields,
					systemLogField: item,
					modalOption: name,
				});
				setOpenSystemLogFieldCrud(true);
				break;

			case "Eraser":
				setOpenConfirmModalCompanyFields(true);
				setOpenDeleteCompanyFields(item);
				break;

			default:
				break;
		}
	};

	const deleteCompanyFields = async (item) => {
		setCompanyFieldsD([...companyFieldsD, item.label]);
		setFormData({
			...formData,
			companyFields: reject(formData.companyFields, { label: item.label }),
		});
		setOpenConfirmModalCompanyFields(false);

		const updatedCompanyFields = reject(formData.companyFields, { label: item.label });
		await dispatch(
			genericAction({
				method: "patch",
				route: `company/${tableValue.id}`,
				body: { companyFields: updatedCompanyFields },
			})
		);
	};

	const systemLogFieldHandler = (item, modalOptions, oldItem) => {
		let newSystemLogField = formData.companyFields;

		switch (modalOptions) {
			case "Add":
				newSystemLogField = [...newSystemLogField, item];
				break;

			case "Edit":
				newSystemLogField = [...reject(newSystemLogField, { label: oldItem.label }), item];
				break;

			default:
				break;
		}

		setFormData({ ...formData, companyFields: newSystemLogField });
	};

	const alertTimesHandlerTable = (name, item) => {
		if (name === "Edit") {
			setAlertItem(item);

			setOpenAlertTimes(true);
		}
	};

	// save handlers
	const handlerSaved = async () => {
		let validationObj = {
			name: nameCompany,
			userLimit,
			sessionTimeout,
			domainErr: formData.domain,
			typeAsignation,
			suggestQA,
			images,
			isPromo,
			promoList,
			tagList,
		};

		validationObj = {
			...validationObj,
		};
		const validation = schema.validate(validationObj, { abortEarly: false });
		if (validation.error) {
			const errorss = validation.error.details.reduce(
				(acc, item) => {
					acc[item.context.key] = item.message;
					return acc;
				},
				{
					name: "",
					domainErr: "",
					typeAsignation: "",
					suggestQA: "",
					images: [],
					userLimit: "",
					sessionTimeout: "",
					promoList: "",
					tagList: "",
				}
			);
			setErrors(errorss);
			return;
		}

		if (modalOption === "Add") {
			const settingsData = {
				userLimit: !isEmpty(userLimit) || isNumber(userLimit) ? parseInt(userLimit, 10) : 0,
				// defaultGroup: isNumber(formData.defaultGroup) ? formData.defaultGroup : null,
				sessionTimeout: parseInt(sessionTimeout, 10),
				// assignChats: formData.assignChats,
				tagOnClose,
				applyConsent,
				sendFlow,
				isPromo,
				endChatNoResponse,
				canLogoutWithAssignedChats,
				isBlocked,
				suggestQA,
				clientExpiredTime: Number(clientExpiredTime),
				alerts,
				welcomeMessageId: !isEmpty(formData.welcomeMessageId) ? formData.welcomeMessageId : [],
				startMessageId: !isEmpty(formData.startMessageId) ? formData.startMessageId : [],
				closeMessageId: !isEmpty(formData.closeMessageId) ? formData.closeMessageId : [],
				outOfScheduleMessageId: !isEmpty(formData.outOfScheduleMessageId) ? formData.outOfScheduleMessageId : [],
				// surveyId: isNumber(formData.surveyId) ? formData.surveyId : null,
				colors,
				typeAsignation,
				alwaysOpen,
				fixedFields: map(formData.fixedFields, (field) => {
					return {
						label: field.label,
						isEditable: field.isEditable,
						isRequired: field.isRequired,
					};
				}),
				autoCloseChatInHrs: parseInt(clientTime, 10),
				closingKeywords: trim(closingKeywords)
					? map(split(closingKeywords, ","), (k) => {
							return trim(k);
					  })
					: [],
				blackListKeyWords: trim(blackListKeyWords)
					? map(split(blackListKeyWords, ","), (k) => {
							return trim(k);
					  })
					: [],
				promoList: trim(promoList)
					? map(split(promoList, ","), (k) => {
							return trim(k);
					  })
					: [],
				flowKeywords: trim(flowKeywords)
					? map(split(flowKeywords, ","), (k) => {
							return trim(k);
					  })
					: [],
				tagList: trim(tagList)
					? map(split(tagList, ","), (k) => {
							return trim(k);
					  })
					: [],
			};

			const newSchedules = schedules.map((item) => {
				return {
					day: item.days,
					startHour: item.beginTime ? moment(item.beginTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
					endHour: item.endTime ? moment(item.endTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
				};
			});

			const addData = {
				name: nameCompany,
				domain: formData.domain,
				isActive: state,
				settings: settingsData,
				logo: !isEmpty(images) ? [images[0]] : [],
				companyFields: formData.companyFields,
				channels: channelTableData,
				schedules: newSchedules,
			};

			const responseData = await dispatch(genericAction({ method: "post", route: `company`, body: addData }));
			if (responseData) {
				refresh();
				onClose();
			}
		} else {
			// const newSchedules = schedules.map((item) => {
			// 	return {
			// 		...(item.id && { id: item.id }),
			// 		day: item.days ? item.days.charAt(0).toUpperCase() + item.days.slice(1).toLowerCase() : null,
			// 		startHour: item.beginTime ? moment(item.beginTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
			// 		endHour: item.endTime ? moment(item.endTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
			// 	};
			// });
			let newSchedules = initialFormData.schedule;

			if (newSchedules.length > 0) {
				newSchedules = schedules.map((item) => {
					return {
						...(item.id && { id: item.id }),
						day: item.days ? item.days.charAt(0).toUpperCase() + item.days.slice(1).toLowerCase() : null,
						startHour: item.beginTime ? moment(item.beginTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
						endHour: item.endTime ? moment(item.endTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
					};
				});
			} else {
				newSchedules = schedules.map((item) => {
					return {
						day: item.days ? item.days.charAt(0).toUpperCase() + item.days.slice(1).toLowerCase() : null,
						startHour: item.beginTime ? moment(item.beginTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
						endHour: item.endTime ? moment(item.endTime, ["HH:mm", "HH:mm:ss"]).format("HH:mm:ss") : null,
					};
				});
			}

			const closingKeywordsArray = trim(closingKeywords)
				? filter(
						map(split(closingKeywords, ","), (k) => {
							return trim(k);
						}),
						(k) => {
							return k !== "";
						}
				  )
				: [];

			const blackListKeyWordsArray = trim(blackListKeyWords)
				? filter(
						map(split(blackListKeyWords, ","), (k) => {
							return trim(k);
						}),
						(k) => {
							return k !== "";
						}
				  )
				: [];

			const promoListArray = trim(promoList)
				? filter(
						map(split(promoList, ","), (k) => {
							return trim(k);
						}),
						(k) => {
							return k !== "";
						}
				  )
				: [];

			const flowKeywordsArray = trim(flowKeywords)
				? filter(
						map(split(flowKeywords, ","), (k) => {
							return trim(k);
						}),
						(k) => {
							return k !== "";
						}
				  )
				: [];

			const tagListArray = trim(tagList)
				? filter(
						map(split(tagList, ","), (k) => {
							return trim(k);
						}),
						(k) => {
							return k !== "";
						}
				  )
				: [];

			const settingsData = {
				userLimit: !isEmpty(userLimit) || isNumber(userLimit) ? parseInt(userLimit, 10) : null,
				sessionTimeout: parseInt(sessionTimeout, 10),
				tagOnClose,
				applyConsent,
				endChatNoResponse,
				canLogoutWithAssignedChats,
				isBlocked,
				suggestQA,
				sendFlow,
				isPromo,
				clientExpiredTime: Number(clientExpiredTime),
				alerts,
				welcomeMessageId: !isEmpty(formData.welcomeMessageId) ? formData.welcomeMessageId : [],
				startMessageId: !isEmpty(formData.startMessageId) ? formData.startMessageId : [],
				closeMessageId: !isEmpty(formData.closeMessageId) ? formData.closeMessageId : [],
				outOfScheduleMessageId: !isEmpty(formData.outOfScheduleMessageId) ? formData.outOfScheduleMessageId : [],
				colors,
				typeAsignation,
				botWarning: Number(botWarning),
				botTimeout: Number(botTimeout),
				alwaysOpen,
				fixedFields: formData.fixedFields.map((field) => {
					return {
						label: field.label,
						isEditable: field.isEditable,
						isRequired: field.isRequired,
					};
				}),
				autoCloseChatInHrs: parseInt(clientTime, 10),
				closingKeywords: closingKeywordsArray,
				blackListKeyWords: blackListKeyWordsArray,
				promoList: promoListArray,
				flowKeywords: flowKeywordsArray,
				tagList: tagListArray,
			};

			let dataEdit = {
				id,
			};

			if (!isEqual(nameCompany, initialFormData.name)) dataEdit = { ...dataEdit, name: nameCompany };
			if (!isEqual(formData.domain, initialFormData.domain)) dataEdit = { ...dataEdit, domain: formData.domain };
			if (!isEqual(state, initialFormData.state)) dataEdit = { ...dataEdit, isActive: state };
			if (!isEqual(formData.companyFields, initialFormData.companyFields))
				dataEdit = { ...dataEdit, companyFields: formData.companyFields };

			// if (!isEqual(schedules, initialFormData.schedules)) dataEdit = { ...dataEdit, schedule: newSchedules };
			if (!isEqual(schedulesFeriados, initialFormData.holidays)) dataEdit = { ...dataEdit, holidays: schedulesFeriados };
			if (!isEqual(holidayToDelete, initialFormData.holidaysD)) dataEdit = { ...dataEdit, holidaysD: holidayToDelete };
			// if (!isEqual(alerts, initialFormData.settings.alerts)) dataEdit = { ...dataEdit, settings: { ...settingsData, alerts } };

			if (orderWeek(schedules) !== orderWeek(initialFormData.schedule)) dataEdit = { ...dataEdit, schedule: newSchedules };

			// if (!isEmpty(companyFieldsD)) {
			// 	dataEdit = { ...dataEdit, companyFieldsD };
			// }

			const mapDataChannel = filter(channelTableData, (item) => {
				return !item.id;
			});

			if (!isEmpty(mapDataChannel)) {
				dataEdit = { ...dataEdit, channels: mapDataChannel };
			}
			if (!isEqual(settingsData, data.settings)) dataEdit = { ...dataEdit, settings: settingsData };
			if ((!isEqual(images[0], initialFormData.logo) && images.length > 0) || (images.length === 0 && initialFormData.logo !== null)) {
				if (images.length > 0) {
					dataEdit = { ...dataEdit, logo: images };
				} else {
					dataEdit = { ...dataEdit, logo: null };
				}
			}

			await dispatch(genericAction({ method: "patch", route: `company/${tableValue.id}`, body: dataEdit }));
			setErrors({ name: "", userLimit: "", sessionTimeout: "", domainErr: "", typeAsignation: "", suggestQA: "", images: [] });
		}
		refresh();
		onClose();
	};

	const handleCancel = () => {
		if (channelTableData.length > (initialFormData?.channels?.length ?? 0)) {
			setOpenCancelConfirm(true);
		} else {
			onClose();
		}
	};

	const isVisible = (rowData) => {
		return !rowData.id;
	};

	const handleApplyToAllClear = () => {
		const updatedScheduleDataDays = schedules.map((item) => {
			return {
				...item,
				beginTime: "",
				endTime: "",
			};
		});
		setSchedules(updatedScheduleDataDays);
	};

	const handleApplyToAllAlwaysOpenFeriados = (action, item) => {
		switch (action) {
			case "Add":
				setOpenAddHoliDay(true);
				setItemEditHoliDay({});
				break;
			case "Edit":
				setItemEditHoliDay(item);
				setOpenAddHoliDay(true);
				break;
			case "Eraser": {
				setOpenAlertsDelete(true);
				setAlertsToDelete(item);
				break;
			}
			default:
				break;
		}
	};

	const renderAlertsDelete = (item) => {
		const updatedFeriados = reject(schedulesFeriados, (feriado) => {
			return feriado.id === item.id;
		});

		setSchedulesFeriados(updatedFeriados);
		setHolidayToDelete((prev) => {
			return [...prev, item.id];
		});
		setOpenAlertsDelete(false);
	};

	const handleSaveHoliDay = (item) => {
		setSchedulesFeriados(item);
	};
	// const isVisibleAction = (item) => {
	// 	const today = new Date();
	// 	const itemDate = new Date(item.date);

	// 	if (today > itemDate) {
	// 		return true;
	// 	}
	// 	if (!item.id) {
	// 		return true;
	// 	}
	// 	return false;
	// };

	// const isVisibleActionD = (item) => {
	// 	const today = new Date();
	// 	const itemDate = new Date(item.date);

	// 	if (today > itemDate) {
	// 		return true;
	// 	}

	// 	return false;
	// };

	const handleApplyToAllOpen = () => {
		const updatedScheduleDataDays = schedules.map((item) => {
			return {
				...item,
				beginTime: "00:00",
				endTime: "23:59",
			};
		});
		setSchedules(updatedScheduleDataDays);
	};

	const handleCopyLink = () => {
		if (companyLink) {
			navigator.clipboard.writeText(companyLink).then(() => {
				setCopied(true);
				setTimeout(() => {
					return setCopied(false);
				}, 1500);
			});
		}
	};

	const handleCopyPin = () => {
		if (pin) {
			navigator.clipboard.writeText(pin).then(() => {
				setCopiedPin(true);
				setTimeout(() => {
					return setCopiedPin(false);
				}, 1500);
			});
		}
	};

	const handleCopyLoginLink = () => {
		if (loginLink) {
			navigator.clipboard.writeText(loginLink).then(() => {
				setCopiedLogin(true);
				setTimeout(() => {
					return setCopiedLogin(false);
				}, 1500);
			});
		}
	};

	const cleanChats = async () => {
		setOpenCleanChats(true);
	};
	const cleanChatsh = async () => {
		setOpenCleanChatsh(true);
	};

	const handleCleanChats = async () => {
		await dispatch(genericAction({ method: "POST", route: `master/wipeChats`, body: { companyId: tableValue.id, withHistoric: false } }));
		setOpenCleanChats(false);
	};

	const handleCleanChatsH = async () => {
		await dispatch(genericAction({ method: "POST", route: `master/wipeChats`, body: { companyId: tableValue.id, withHistoric: true } }));
		setOpenCleanChatsh(false);
	};

	const handleCheckboxChange = (field, type, checked) => {
		setFormData((prevState) => {
			const updatedFixedFields = prevState.fixedFields.map((item) => {
				if (item.label === field) {
					if (type === "isEditable") {
						return { ...item, isEditable: checked };
					}

					if (type === "isRequired") {
						return { ...item, isRequired: checked };
					}
				}
				return item;
			});

			return { ...prevState, fixedFields: updatedFixedFields };
		});
	};

	return (
		<Modal size="tiny" className={styles.modalFirst} open closeIcon onClose={onClose}>
			<Modal.Header className={styles.modalHeader}>
				<div className={styles.modalHeader}>
					<div style={{ display: "flex", alignItems: "center" }}>
						{modalOption === "Watch" && <Icon name="eye" />}
						{modalOption === "Edit" && <Icon name="edit" />}
						{modalOption === "Add" && <Icon name="plus" />}
						<span style={{ marginLeft: "8px", marginTop: "10px" }}>
							{" "}
							Maestro Compañía
							{modalOption !== "Add" && `: ${String(tableValue.name)}  - Id: ${String(tableValue.id)}`}
						</span>
					</div>
				</div>

				<div>
					{modalOption === "Watch" && (
						<Button
							onClick={() => {
								setModalOption("Edit");
							}}
							className={styles.modalButtonEdit}>
							<Icon name="edit" />
						</Button>
					)}

					{modalOption === "Edit" && (
						<Button
							onClick={() => {
								setModalOption("Watch");
							}}
							className={styles.modalButtonWatch}>
							<Icon name="eye" />
						</Button>
					)}
				</div>
			</Modal.Header>
			<div className={styles.divHeaderNav}>
				<div className={styles.ErrorCitas}>
					<Button
						className={`${stateHeader === "infobasic" ? `${styles.navButton} ${styles.active}` : styles.navButton} ${
							!isEmpty(errors.name) || !isEmpty(errors.domainErr) || !isEmpty(errors.images) ? styles.errorTab : ""
						}`}
						onClick={() => {
							handleStateHeader("infobasic");
						}}>
						Info
					</Button>
				</div>
				<Button
					className={`${stateHeader === "configuration" ? `${styles.navButton} ${styles.active}` : styles.navButton} ${
						!isEmpty(errors.userLimit) || !isEmpty(errors.sessionTimeout) || !isEmpty(errors.typeAsignation) || !isEmpty(errors.suggestQA)
							? styles.errorTab
							: ""
					}`}
					onClick={() => {
						handleStateHeader("configuration");
					}}>
					Configuración
				</Button>
				<Button
					className={stateHeader === "channels" ? `${styles.navButton} ${styles.active}` : styles.navButton}
					onClick={() => {
						handleStateHeader("channels");
					}}>
					Canales {!isEmpty(channelTableData) ? `(${channelTableData.length})` : ""}
				</Button>
				<Button
					className={stateHeader === "systemRegister" ? `${styles.navButton} ${styles.active}` : styles.navButton}
					onClick={() => {
						handleStateHeader("systemRegister");
					}}>
					Registro de Información {!isEmpty(formData.companyFields) ? `(${formData.companyFields.length})` : ""}
				</Button>
				<Button
					className={stateHeader === "schedules" ? `${styles.navButton} ${styles.active}` : styles.navButton}
					onClick={() => {
						handleStateHeader("schedules");
					}}>
					Horarios
				</Button>
				<Button
					className={stateHeader === "colors" ? `${styles.navButton} ${styles.active}` : styles.navButton}
					onClick={() => {
						handleStateHeader("colors");
					}}>
					Colores
				</Button>
			</div>
			<Modal.Content className={styles.modalContent} scrolling>
				<div className={styles.screen}>
					<div className={styles.mainContainer}>
						{/* ******  Informacion Basica  **************** */}
						{stateHeader === "infobasic" && (
							<Form noValidate className={styles.basicInformationContainer}>
								<div className={styles.listContainer}>
									<fieldset className={styles.firstfieldsetWorsd}>
										<legend className={styles.legend}>Información básica</legend>
										<div className={styles.infoBasicContainer}>
											<div className={styles.rowOneBasicInfo}>
												<Input
													value={nameCompany}
													icon="home"
													name="name"
													label="Nombre"
													autoComplete="off"
													className={styles.inputName}
													style={{ width: "100%" }}
													required
													disabled={modalOption === "Watch"}
													error={!isEmpty(errors.name) && { content: errors.name, pointing: "above" }}
													onChange={(e) => {
														setNameCompany(e.target.value);
													}}
												/>
												<div className={styles.divState}>
													<span className={styles.label1}>Estado:</span>
													<Checkbox
														id="a"
														toggle
														label={state ? "Activa" : "Inactiva"}
														name="state"
														checked={state}
														onChange={(e, { checked }) => {
															setState(checked);
														}}
														disabled={modalOption === "Watch"}
													/>
												</div>
											</div>
											<div className={styles.rowTwoBasicInfo}>
												<div className={styles.pinContainer}>
													<Form.Input
														className={styles.pinInput}
														disabled={modalOption === "Watch"}
														name="pin"
														value={pin}
														type={showPin ? "text" : "password"}
														fluid
														label="Pin"
														style={{ width: "100%" }}
													/>
													<Button
														icon={showPin ? "eye slash" : "eye"}
														onClick={(e) => {
															e.preventDefault();
															setShowPin(!showPin);
														}}
														compact
														className={styles.showButton}
													/>
													{modalCrud === "Add" && (
														<Button
															icon="exchange"
															onClick={(e) => {
																e.preventDefault();
																changePin();
															}}
															compact
															disabled={modalOption === "Watch"}
															className={styles.changeButton}
														/>
													)}
													<div className={styles.copyContainerPin}>
														<Icon name="copy outline" size="big" className={styles.icon} onClick={handleCopyPin} />
														{copiedPin && <span className={styles.tooltipPin}>¡Copiado!</span>}
													</div>
												</div>
												<div className={styles.logoCont} style={{ marginLeft: 0 }}>
													<FileManager
														links={links}
														disabled={modalOption === "Watch"}
														images={images}
														imagesD={imagesD}
														setLinks={setLinks}
														setImages={setImages}
														setImagesD={setImagesD}
													/>
													<Label className={styles.messageError} style={isEmpty(errors.images) ? { display: "none" } : null} prompt>
														{errors.images}
													</Label>
												</div>
											</div>
										</div>
									</fieldset>

									<fieldset className={styles.firstfieldsetWorsd}>
										<legend className={styles.legend}>Links</legend>
										<div className={styles.linksContainerColumn}>
											<Input
												placeholder="Dominio"
												label="Dominio: "
												required
												value={formData.domain}
												className={styles.companyLinks}
												fluid
												disabled={modalOption === "Watch"}
												onChange={(e) => {
													return setFormData({ ...formData, domain: e.target.value });
												}}
												error={
													!isEmpty(errors.domainErr) && {
														content: errors.domainErr,
														pointing: "above",
													}
												}
											/>
											<div className={styles.rowTwoLinks}>
												<div className={styles.linkItem}>
													<Input
														value={companyLink}
														icon="linkify"
														label="Link para Registro"
														placeholder="Link para registrar usuarios"
														fluid
														disabled
														className={styles.companyLink}
														style={{ flex: 1 }}
													/>
													<div className={styles.copyContainerPin}>
														<Icon name="copy outline" size="big" className={styles.icon} onClick={handleCopyLink} />
														{copied && <span className={styles.tooltipPin}>¡Copiado!</span>}
													</div>
												</div>
												<div className={styles.linkItem}>
													<Input
														value={loginLink}
														icon="sign in"
														label="Link para Login"
														placeholder="Link para iniciar sesión"
														fluid
														disabled
														className={styles.companyLink}
														style={{ flex: 1 }}
													/>
													<div className={styles.copyContainerPin}>
														<Icon name="copy outline" size="big" className={styles.icon} onClick={handleCopyLoginLink} />
														{copiedLogin && <span className={styles.tooltipPin}>¡Copiado!</span>}
													</div>
												</div>
											</div>
										</div>
									</fieldset>
								</div>
								<div className={styles.listContainer}>
									<fieldset className={styles.firstfieldsetWorsd} style={{ marginTop: "15px" }}>
										<legend className={styles.legend}>Lista Negra Inicio Chat (Separadas por comas)</legend>
										<div className={styles.linksContainer}>
											<div className={styles.inputLink}>
												<InputTextArea
													value={closingKeywords}
													placeholder="Ingresa las palabras clave separadas por comas..."
													name="closingKeywords"
													style={{ width: "100%", minHeight: "100px !important" }}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														setClosingKeywords(e.target.value);
													}}
												/>
											</div>
										</div>
									</fieldset>
									<fieldset className={styles.firstfieldsetWorsd} style={{ marginTop: "15px" }}>
										<legend className={styles.legend}>Lista Negra Envío (Separadas por comas)</legend>
										<div className={styles.linksContainer}>
											<div className={styles.inputLink}>
												<InputTextArea
													value={blackListKeyWords}
													placeholder="Ingresa las palabras clave separadas por comas..."
													name="blackListKeyWords"
													style={{ width: "100%", minHeight: "100px !important" }}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														setBlackListKeyWords(e.target.value);
													}}
												/>
											</div>
										</div>
									</fieldset>
									<fieldset className={styles.firstfieldsetWorsd} style={{ marginTop: "15px" }}>
										<legend className={styles.legend}>Palabras Clave para Flow (Separadas por comas)</legend>
										<div className={styles.linksContainer}>
											<div className={styles.inputLink}>
												<InputTextArea
													value={flowKeywords}
													placeholder="Ingresa las palabras clave separadas por comas..."
													name="flowKeywords"
													style={{ width: "100%", minHeight: "100px !important" }}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														setFlowKeywords(e.target.value);
													}}
												/>
											</div>
										</div>
									</fieldset>
								</div>
								{isPromo && (
									<div className={styles.listContainer}>
										<fieldset className={styles.firstfieldsetWorsd} style={{ marginTop: "15px" }}>
											<legend className={styles.legend}>Palabras Promo (Separadas por comas)</legend>
											<div className={styles.linksContainer}>
												<div className={styles.inputLink}>
													<InputTextArea
														value={promoList}
														placeholder="Ingresa las palabras clave separadas por comas..."
														name="promoList"
														style={{ width: "100%", minHeight: "100px !important", ...(errors.promoList ? { borderColor: "red" } : {}) }}
														disabled={modalOption === "Watch"}
														onChange={(e) => {
															setPromoList(e.target.value);
														}}
													/>
													<Label
														className={styles.messageError}
														style={isEmpty(errors.promoList) ? { display: "none" } : { marginTop: "5px" }}
														prompt>
														{errors.promoList}
													</Label>
												</div>
											</div>
										</fieldset>
										<fieldset className={styles.firstfieldsetWorsd} style={{ marginTop: "15px" }}>
											<legend className={styles.legend}>Etiquetas Promo (Separadas por comas)</legend>
											<div className={styles.linksContainer}>
												<div className={styles.inputLink}>
													<InputTextArea
														value={tagList}
														placeholder="Ingresa las palabras clave separadas por comas..."
														name="tagList"
														style={{ width: "100%", minHeight: "100px !important", ...(errors.tagList ? { borderColor: "red" } : {}) }}
														disabled={modalOption === "Watch"}
														onChange={(e) => {
															setTagList(e.target.value);
														}}
													/>
													<Label
														className={styles.messageError}
														style={isEmpty(errors.tagList) ? { display: "none" } : { marginTop: "5px" }}
														prompt>
														{errors.tagList}
													</Label>
												</div>
											</div>
										</fieldset>
									</div>
								)}
							</Form>
						)}
						{stateHeader === "configuration" && (
							<>
								<div className={styles.configBlocksContainer}>
									<fieldset className={styles.configBlock}>
										<legend className={styles.legend}>
											<Icon name="cog" /> General
										</legend>
										<div className={styles.tableContainerGrid}>
											<div className={`${styles.configFieldItem}`}>
												<span className={styles.rigthLabel} style={{ marginLeft: 0 }}>
													Límite de usuarios <span className={styles.labelRequired}>*</span>
												</span>
												<Input
													value={String(userLimit)}
													icon="user"
													name="userLimit"
													labelPosition="right"
													fluid
													className={styles.inputFullWidth}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														setUserLimit(e.target.value);
													}}
												/>
												<Label className={styles.messageError} style={isEmpty(errors.userLimit) ? { display: "none" } : null} prompt>
													{errors.userLimit}
												</Label>
											</div>

											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Tipo de Asignación:<span className={styles.labelRequired}>*</span>
												</span>
												<Dropdown
													className={styles.dropdownStyleAsignation}
													required
													placeholder="Tipo de Asignación"
													fluid
													clearable
													value={typeAsignation}
													name="typeAsignation"
													search
													selection
													disabled={modalOption === "Watch"}
													onChange={(e, { value }) => {
														setTypeAsignation(value);
													}}
													options={[
														{ key: 1, text: "Manual", value: "Manual" },
														{ key: 2, text: "Balanceado", value: "Balanced" },
														{ key: 3, text: "Round Robin", value: "Round Robin" },
													]}
												/>
												<Label className={styles.messageError} style={isEmpty(errors.typeAsignation) ? { display: "none" } : null} prompt>
													{errors.typeAsignation}
												</Label>
											</div>

											<div className={styles.configFieldItem}>
												<span className={styles.rigthLabel} style={{ marginLeft: 0 }}>
													Resp. Rápida:<span className={styles.labelRequired}>*</span>
												</span>
												<Dropdown
													className={styles.dropdownStyleAsignation}
													required
													placeholder="Seleccionar modo"
													fluid
													clearable={false}
													value={suggestQA}
													name="suggestQA"
													search
													selection
													disabled={modalOption === "Watch"}
													error={!isEmpty(errors.suggestQA) && { content: errors.suggestQA, pointing: "above" }}
													onChange={(e, { value }) => {
														setSuggestQA(value);
													}}
													options={[
														{ key: 1, text: "Sugerir", value: "Sugerir" },
														{ key: 2, text: "Múltiple", value: "Múltiple" },
														{ key: 3, text: "Individual", value: "Individual" },
													]}
												/>
												<Label
													className={styles.messageError}
													style={isEmpty(errors.suggestQA) ? { display: "none" } : null}
													pointing
													prompt>
													{errors.suggestQA}
												</Label>
											</div>

											{(typeAsignation === 2 || typeAsignation === 3) && (
												<div className={`${styles.userLimitTab} ${styles.spanTwoCols}`} style={{ gap: "0.5rem" }}>
													{/* keeping userLimitTab for specific flex direction but override grid col */}
													<span className={styles.span} style={{ margin: 0 }}>
														Tab de Entrada:
													</span>
													<Dropdown
														className={styles.dropdownStyleAsignation}
														required
														placeholder="Tipo de Asignación"
														fluid
														clearable
														name="typeAsignation"
														search
														selection
														disabled={modalOption === "Watch"}
														options={[
															{ key: 1, text: "Nuevo", value: 1 },
															{ key: 2, text: "Atender", value: 2 },
														]}
													/>
												</div>
											)}
										</div>
									</fieldset>

									<fieldset className={styles.configBlock}>
										<legend className={styles.legend}>
											<Icon name="clock" /> Tiempos
										</legend>
										<div className={styles.tableContainerGrid}>
											<div className={styles.configFieldItem}>
												<span className={styles.rigthLabel} style={{ marginLeft: 0 }}>
													Cerrar sesión inactiva (Min):<span className={styles.labelRequired}>*</span>
												</span>
												<Input
													value={String(sessionTimeout)}
													icon="time"
													placeholder="Minutos"
													name="sessionTimeout"
													fluid
													className={styles.inputFullWidth}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														setSessionTimeout(e.target.value);
													}}
												/>
												<Label className={styles.messageError} style={isEmpty(errors.sessionTimeout) ? { display: "none" } : null} prompt>
													{errors.sessionTimeout}
												</Label>
											</div>

											<div className={styles.configFieldItem}>
												<span className={styles.rigthLabel} style={{ marginLeft: 0 }}>
													Cierre de Chat Au.: (Horas)
												</span>
												<Input
													value={String(clientTime)}
													icon="time"
													placeholder="Horas"
													name="clientTime"
													fluid
													className={styles.inputFullWidth}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														setClientTime(e.target.value);
													}}
												/>
											</div>

											<div className={styles.configFieldItem}>
												<span className={styles.rigthLabel} style={{ marginLeft: 0 }}>
													Tiempo de Aviso: (Min)
												</span>
												<Input
													value={String(botWarning)}
													icon="time"
													placeholder="Minutos"
													name="botWarning"
													fluid
													className={styles.inputFullWidth}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														return setBotWarning(e.target.value);
													}}
												/>
											</div>

											<div className={styles.configFieldItem}>
												<span className={styles.rigthLabel} style={{ marginLeft: 0 }}>
													Tiempo de Timeout: (Min)
												</span>
												<Input
													value={String(botTimeout)}
													labelPosition="right"
													icon="time"
													placeholder="Minutos"
													name="botTimeout"
													fluid
													className={styles.inputFullWidth}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														return setBotTimeout(e.target.value);
													}}
												/>
											</div>
										</div>
									</fieldset>

									{/* **************  Tiempos de Alertas ****************** */}
									<fieldset className={styles.configBlock}>
										<legend className={styles.legend}>
											<Icon name="alarm" /> Tiempos de Alertas
										</legend>
										<div className={styles.tableContainer} style={{ padding: 0 }}>
											<div className={`${styles.containerHeaderInput} ${styles.alertHeaderInput}`}>
												<span className={styles.rigthLabel}>Vencido Cliente (Min):</span>
												<Input
													value={String(clientExpiredTime)}
													icon="time"
													placeholder="Minutos"
													name="clientExpiredTime"
													className={styles.rightInput}
													disabled={modalOption === "Watch"}
													onChange={(e) => {
														setClientExpiredTime(e.target.value);
													}}
												/>
											</div>
											<NewTable
												data={alerts}
												columns={[
													{
														label: "Acciones",
														action: [{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" }],
														dataPosition: "center",
														width: 1,
														hidden: modalOption === "Watch",
													},
													{
														label: "Nombre",
														key: "name",
														format: "string",
														width: 1,
													},
													{
														label: "Color",
														key: "color",
														format: "label",
														colorLabel: [
															{ onName: "green", color: "green" },
															{ onName: "orange", color: "orange" },
															{ onName: "gold", color: "gold" },
															{ onName: "red", color: "red" },
														],
														width: 1,
													},
													{
														label: "Minutos",
														key: "time",
														format: "string",
														dataPosition: "center",
														width: 1,
													},
												]}
												defaultOrder={{ key: "name", dir: "asc" }}
												pageRows={100}
												handlerTable={alertTimesHandlerTable}
												haveFooter={false}
												searchPosition="left"
											/>
										</div>
									</fieldset>
								</div>
								<div className={styles.configBlocksContainer}>
									{/* **************  Aplica ****************** */}
									<fieldset className={styles.configBlock}>
										<legend className={styles.legend}>
											<Icon name="check square" /> Aplica
										</legend>
										<div className={styles.tableContainerGrid}>
											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Cierre de chat Etiquetado
												</span>
												<div className={styles.checkboxWrapper}>
													<Checkbox
														toggle
														name="tagOnClose"
														checked={tagOnClose}
														onChange={(e, { checked }) => {
															setTagOnClose(checked);
														}}
														disabled={modalOption === "Watch"}
														label={tagOnClose ? "Si" : "No"}
													/>
												</div>
											</div>
											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Consentimiento
												</span>
												<div className={styles.checkboxWrapper}>
													<Checkbox
														toggle
														name="applyConsent"
														checked={applyConsent}
														onChange={(e, { checked }) => {
															setApplyConsent(checked);
														}}
														disabled={modalOption === "Watch"}
														label={applyConsent ? "Si" : "No"}
													/>
												</div>
											</div>
											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Finalizar sin atender
												</span>
												<div className={styles.checkboxWrapper}>
													<Checkbox
														toggle
														name="endChatNoResponse"
														checked={endChatNoResponse}
														disabled={modalOption === "Watch"}
														onChange={(e, { checked }) => {
															setEndChatNoResponse(checked);
														}}
														label={endChatNoResponse ? "Si" : "No"}
													/>
												</div>
											</div>
											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Desconectar con chat pendiente
												</span>
												<div className={styles.checkboxWrapper}>
													<Checkbox
														toggle
														name="canLogoutWithAssignedChats"
														checked={canLogoutWithAssignedChats}
														disabled={modalOption === "Watch"}
														onChange={(e, { checked }) => {
															setCanLogoutWithAssignedChats(checked);
														}}
														label={canLogoutWithAssignedChats ? "Si" : "No"}
													/>
												</div>
											</div>
											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Bloquear contacto
												</span>
												<div className={styles.checkboxWrapper}>
													<Checkbox
														toggle
														name="isBlocked"
														checked={isBlocked}
														disabled={modalOption === "Watch"}
														onChange={(e, { checked }) => {
															setIsBlocked(checked);
														}}
														label={isBlocked ? "Si" : "No"}
													/>
												</div>
											</div>
											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Enviar Flow
												</span>
												<div className={styles.checkboxWrapper}>
													<Checkbox
														toggle
														name="sendFlow"
														checked={sendFlow}
														disabled={modalOption === "Watch"}
														onChange={(e, { checked }) => {
															setSendFlow(checked);
														}}
														label={sendFlow ? "Si" : "No"}
													/>
												</div>
											</div>
											<div className={styles.configFieldItem}>
												<span className={styles.span} style={{ margin: 0 }}>
													Promo
												</span>
												<div className={styles.checkboxWrapper}>
													<Checkbox
														toggle
														name="isPromo"
														checked={isPromo}
														disabled={modalOption === "Watch"}
														onChange={(e, { checked }) => {
															setIsPromo(checked);
														}}
														label={isPromo ? "Si" : "No"}
													/>
												</div>
											</div>
										</div>
									</fieldset>

									{/* **********************  Mensajes ************************ */}
									<fieldset className={styles.configBlock}>
										<legend className={styles.legend}>
											<Icon name="mail" /> Mensajes Automatizados
										</legend>
										<div className={styles.tableContainerFlex}>
											<Form.Field>
												<span className={styles.label3}>Bienvenida:</span>
												<Dropdown
													fluid
													multiple
													clearable
													search
													selection
													placeholder="Elegir Mensaje"
													name="welcomeMessageId"
													value={formData.welcomeMessageId}
													options={predWelcomeData}
													onChange={dorpdownHandler}
													disabled={modalOption === "Watch"}
												/>
											</Form.Field>

											<Form.Field>
												<span className={styles.label3}>Inicio:</span>
												<Dropdown
													fluid
													multiple
													clearable
													search
													selection
													placeholder="Elegir Mensaje"
													name="startMessageId"
													value={formData.startMessageId}
													options={predBeginData}
													onChange={dorpdownHandler}
													disabled={modalOption === "Watch"}
												/>
											</Form.Field>

											<Form.Field>
												<span className={styles.label3}>Cierre:</span>
												<Dropdown
													fluid
													multiple
													clearable
													search
													selection
													placeholder="Elegir Mensaje"
													name="closeMessageId"
													value={formData.closeMessageId}
													options={predCloseData}
													onChange={dorpdownHandler}
													disabled={modalOption === "Watch"}
												/>
											</Form.Field>

											<Form.Field>
												<span className={styles.label3}>Fuera de Horario:</span>
												<Dropdown
													fluid
													multiple
													clearable
													search
													selection
													placeholder="Elegir Mensaje"
													name="outOfScheduleMessageId"
													value={formData.outOfScheduleMessageId}
													options={predTimeOutData}
													onChange={dorpdownHandler}
													disabled={modalOption === "Watch"}
												/>
											</Form.Field>
										</div>
									</fieldset>

									{/* **********************  Registros Fijos ************************ */}
									<fieldset className={styles.configBlock}>
										<legend className={styles.legend}>
											<Icon name="thumbtack" /> Registros Fijos
										</legend>
										<div className={styles.tableContainerS} style={{ padding: 0 }}>
											{/* Nombre */}
											<div className={styles.checkGroup}>
												<div className={styles.checkHeader}>
													<span className={styles.classSpan}>Nombre:</span>
													<span className={styles.checkLabel}>Editable</span>
													<span className={styles.checkLabel}>Requerido</span>
												</div>
												<div className={styles.checkBody}>
													<span className={styles.emptySpan} />
													<Checkbox
														toggle
														name="nameEditable"
														checked={
															formData.fixedFields.find((field) => {
																return field.label === "name";
															}).isEditable
														}
														onChange={(e, { checked }) => {
															return handleCheckboxChange("name", "isEditable", checked);
														}}
														disabled={modalOption === "Watch"}
														label={
															formData.fixedFields.find((field) => {
																return field.label === "name";
															}).isEditable
																? "Sí"
																: "No"
														}
													/>

													<Checkbox
														toggle
														name="nameRequired"
														checked={
															formData.fixedFields.find((field) => {
																return field.label === "name";
															}).isRequired
														}
														onChange={(e, { checked }) => {
															return handleCheckboxChange("name", "isRequired", checked);
														}}
														disabled={modalOption === "Watch"}
														label={
															formData.fixedFields.find((field) => {
																return field.label === "name";
															}).isRequired
																? "Sí"
																: "No"
														}
													/>
												</div>
											</div>

											{/* Teléfono */}
											<div className={styles.checkGroup}>
												<div className={styles.checkHeader}>
													<span className={styles.classSpan}>Teléfono:</span>
													<span className={styles.checkLabel}>Editable</span>
													<span className={styles.checkLabel}>Requerido</span>
												</div>
												<div className={styles.checkBody}>
													<span className={styles.emptySpan} />
													<Checkbox
														toggle
														name="phoneEditable"
														checked={
															formData.fixedFields.find((field) => {
																return field.label === "phone";
															}).isEditable
														}
														onChange={(e, { checked }) => {
															return handleCheckboxChange("phone", "isEditable", checked);
														}}
														disabled={modalOption === "Watch"}
														label={
															formData.fixedFields.find((field) => {
																return field.label === "phone";
															}).isEditable
																? "Sí"
																: "No"
														}
													/>

													<Checkbox
														toggle
														name="phoneRequired"
														checked={
															formData.fixedFields.find((field) => {
																return field.label === "phone";
															}).isRequired
														}
														onChange={(e, { checked }) => {
															return handleCheckboxChange("phone", "isRequired", checked);
														}}
														disabled={modalOption === "Watch"}
														label={
															formData.fixedFields.find((field) => {
																return field.label === "phone";
															}).isRequired
																? "Sí"
																: "No"
														}
													/>
												</div>
											</div>

											{/* Correo */}
											<div className={styles.checkGroup}>
												<div className={styles.checkHeader}>
													<span className={styles.classSpan}>Correo:</span>
													<span className={styles.checkLabel}>Editable</span>
													<span className={styles.checkLabel}>Requerido</span>
												</div>
												<div className={styles.checkBody}>
													<span className={styles.emptySpan} />
													<Checkbox
														toggle
														name="emailEditable"
														checked={
															formData.fixedFields.find((field) => {
																return field.label === "email";
															}).isEditable
														}
														onChange={(e, { checked }) => {
															return handleCheckboxChange("email", "isEditable", checked);
														}}
														disabled={modalOption === "Watch"}
														label={
															formData.fixedFields.find((field) => {
																return field.label === "email";
															}).isEditable
																? "Sí"
																: "No"
														}
													/>

													<Checkbox
														toggle
														name="emailRequired"
														checked={
															formData.fixedFields.find((field) => {
																return field.label === "email";
															}).isRequired
														}
														onChange={(e, { checked }) => {
															return handleCheckboxChange("email", "isRequired", checked);
														}}
														disabled={modalOption === "Watch"}
														label={
															formData.fixedFields.find((field) => {
																return field.label === "email";
															}).isRequired
																? "Sí"
																: "No"
														}
													/>
												</div>
											</div>
										</div>
									</fieldset>
								</div>
							</>
						)}
						{/* ******  Colores  **************** */}
						{stateHeader === "colors" && (
							<fieldset className={styles.cFieldsetOuter}>
								<legend className={styles.cLegendMain}>Personalización de colores</legend>

								<div className={styles.cTableContainer}>
									<div className={styles.cBlocksContainer}>
										{/* === General === */}
										<fieldset className={styles.cFieldset}>
											<legend className={styles.cLegend}>Menú</legend>

											<div className={styles.cGridG}>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Menú:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "primary", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("primary", value);
																}}
															/>
														</div>
													</Form.Field>

													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Texto:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "text", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("text", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Submenú:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "accent", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("accent", value);
																}}
															/>
														</div>
													</Form.Field>

													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Panel:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "panel", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("panel", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Toggle True:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "toggle", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("toggle", value);
																}}
															/>
														</div>
													</Form.Field>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Toggle False:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "toggleFalse", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("toggleFalse", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
											</div>
										</fieldset>

										{/* === Modales / Estados === */}
										<fieldset className={styles.cFieldset}>
											<legend className={styles.cLegend}>Modales</legend>

											<div className={styles.cGridG}>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Header:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "header", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("header", value);
																}}
															/>
														</div>
													</Form.Field>

													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Txt. Header:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "fontsHeader", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("fontsHeader", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Hover:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "accentDarker", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("accentDarker", value);
																}}
															/>
														</div>
													</Form.Field>

													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Txt. Hover:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "fontsHover", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("fontsHover", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Btn. Hover:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "buttons", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("buttons", value);
																}}
															/>
														</div>
													</Form.Field>

													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Txt. Botones:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "fontsButtons", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("fontsButtons", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Panel:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "panelModal", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("panelModal", value);
																}}
															/>
														</div>
													</Form.Field>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Group Header:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "groupHeader", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("groupHeader", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
											</div>
										</fieldset>

										{/* === Formulario === */}
										<fieldset className={styles.cFieldset}>
											<legend className={styles.cLegend}>Formulario</legend>

											<div className={styles.cGridG}>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Header Form:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "headerFormulary", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("headerFormulary", value);
																}}
															/>
														</div>
													</Form.Field>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Txt Form:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "fontFormulary", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("fontFormulary", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
												<div>
													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Buttons Form:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "buttonFormulary", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("buttonFormulary", value);
																}}
															/>
														</div>
													</Form.Field>

													<Form.Field className={styles.cItem}>
														<span className={styles.cLabel}>Hover Btns:</span>
														<div className={styles.cPicker}>
															<ColorPicker
																currentColor={get(colors, "hoverButtonsFormulary", "")}
																disabled={modalOption === "Watch"}
																setCurrentColor={(value) => {
																	return colorHandler("hoverButtonsFormulary", value);
																}}
															/>
														</div>
													</Form.Field>
												</div>
											</div>
										</fieldset>

										{/* === ChatBot === */}
										<fieldset className={styles.cFieldset}>
											<legend className={styles.cLegend}>ChatBot</legend>

											<div className={styles.cGrid2}>
												<Form.Field className={styles.cItem}>
													<span className={styles.cLabel}>Group Color:</span>
													<div className={styles.cPicker}>
														<ColorPicker
															currentColor={get(colors, "groupBack", "")}
															disabled={modalOption === "Watch"}
															setCurrentColor={(value) => {
																return colorHandler("groupBack", value);
															}}
														/>
													</div>
												</Form.Field>
												<Form.Field className={styles.cItem}>
													<span className={styles.cLabel}>Group Txt:</span>
													<div className={styles.cPicker}>
														<ColorPicker
															currentColor={get(colors, "groupFonts", "")}
															disabled={modalOption === "Watch"}
															setCurrentColor={(value) => {
																return colorHandler("groupFonts", value);
															}}
														/>
													</div>
												</Form.Field>
											</div>
										</fieldset>
									</div>
								</div>
							</fieldset>
						)}

						{/* ******  Canales  **************** */}
						{stateHeader === "channels" && (
							<fieldset className={styles.fieldsetCanales}>
								<legend className={styles.legend}>Canales</legend>
								<Grid>
									<Grid.Column className={styles.columnCanales}>
										<Grid.Row className={styles.row}>
											<div className={styles.tableContainer}>
												<NewTable
													data={channelTableData}
													columns={[
														{
															label: "Acciones",
															action: [
																{
																	content: "edit",
																	color: "#3f7ea3",
																	onClick: "Edit",
																	type: "icon",
																	// hidden: modalOption === "Watch",
																	isVisible,
																},
																{
																	content: "trash",
																	color: "#b43333",
																	onClick: "Eraser",
																	type: "icon",
																	isVisible,
																	// hidden: modalOption === "Watch",
																},
															],
															addButton: true,
															hidden: modalOption === "Watch",
															dataPosition: "center",
															width: 1,
														},
														{
															label: "Id",
															key: "id",
															format: "string",
															width: 0.5,
														},
														{
															label: "Activo",
															key: "isActive",
															format: "boolean",
															dataPosition: "center",
															width: 0.5,
														},
														{
															label: "Plataforma",
															key: "platform.name",
															format: "string",
															width: 1,
														},
														{
															label: "ID Plataforma",
															key: "account",
															format: "string",
															width: 1,
														},
														{
															label: "Teléfono/Cuenta",
															key: "label",
															format: "string",
															width: 1,
														},

														{
															label: "Sucursal/Grupo",
															key: "defaultGroup.name",
															format: "string",
															headerPosition: "left",
															width: 16,
														},
													]}
													defaultOrder={{ key: "id", dir: "desc" }}
													pageRows={15}
													handlerTable={channelHandlerTable}
													haveFooter
												/>
											</div>
											{/* <Label className={styles.messageErrorChannels} style={isEmpty(errors.channels) ? { display: "none" } : null} prompt>
												{errors.channels}
											</Label> */}
										</Grid.Row>
									</Grid.Column>
								</Grid>
							</fieldset>
						)}
						{/* ******  Registro de Información  **************** */}
						{stateHeader === "systemRegister" && (
							<fieldset className={styles.fieldsetCanales}>
								<legend className={styles.legend}>Registro de Información</legend>
								<Grid>
									<Grid.Column className={styles.column} width={16}>
										{/* ******** Registro de Información *********** */}

										<Grid.Row className={styles.row}>
											<div className={styles.tableContainer}>
												<NewTable
													data={formData.companyFields}
													columns={[
														{
															label: "Acciones",
															action: [
																{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon", hidden: modalOption === "Watch" },
																{
																	content: "trash",
																	color: "#b43333",
																	onClick: "Eraser",
																	type: "icon",
																	hidden: modalOption === "Watch",
																},
															],
															addButton: true,
															dataPosition: "center",
															width: 1,
															hidden: modalOption === "Watch",
														},
														{
															label: "Orden",
															key: "order",
															format: "string",
															dataPosition: "center",
															width: 1,
														},
														{
															label: "Nombre",
															key: "label",
															format: "truncate",
															stringLength: 30,
															width: 3,
														},
														{
															label: "Requerido",
															key: "isRequired",
															dataPosition: "center",
															format: "boolean",
															width: 1,
														},
														{
															label: "Visible",
															key: "isVisible",
															dataPosition: "center",
															format: "boolean",
															width: 1,
														},
														{
															label: "Editable",
															key: "isUpdateable",
															dataPosition: "center",
															format: "boolean",
															width: 1,
														},
														{
															label: "Tipo",
															key: "type",
															format: "translate",
															translate: [
																{ onName: "string", translate: "Texto" },
																{ onName: "note", translate: "Nota" },
																{ onName: "number", translate: "Numérico" },
																{ onName: "date", translate: "Fecha" },
																{ onName: "enum", translate: "Dropdown" },
																{ onName: "password", translate: "Clave" },
																{ onName: "image", translate: "Imagen" },
																{ onName: "list", translate: "Lista" },
																{ onName: "label", translate: "Label" },
																{ onName: "direction", translate: "Dirección" },
																{ onName: "bool", translate: "Booleano" },
																{ onName: "group", translate: "Grupo" },
															],
															width: 1,
														},
														{
															label: "Icono",
															key: "icon",
															format: "string",
															headerPosition: "left",
															width: 7,
														},
													]}
													defaultOrder={{ key: "order", dir: "asc" }}
													pageRows={15}
													handlerTable={systemLogFieldHandlerTable}
													haveFooter
												/>
											</div>
										</Grid.Row>
									</Grid.Column>
								</Grid>
							</fieldset>
						)}

						{stateHeader === "schedules" && (
							<Grid.Row>
								<Grid.Column width={8}>
									<fieldset className={styles.firstfieldset2}>
										<legend className={styles.legend2}>
											<div className={styles.flexWidth}>
												<Icon className={styles.icon} name="clock outline" />

												<div className={styles.legendTitle}>Horario Lunes - Domingos</div>

												<Icon
													className={styles.iconEye}
													name={isHours ? "eye" : "eye slash"}
													onClick={() => {
														setIsHours(!isHours);
													}}
												/>

												<Form.Checkbox
													disabled={modalOption === "Watch"}
													checked={alwaysOpen}
													value={alwaysOpen}
													className={styles.checkboxContainer24}
													onChange={() => {
														handleApplyToAllOpen();
														setAlwaysOpen(!alwaysOpen);
													}}
													label="24 horas"
													width="8"
												/>
												<Icon
													className={styles.iconClear}
													name="trash"
													disabled={modalOption === "Watch"}
													onClick={() => {
														setAlwaysOpen(false);
														handleApplyToAllClear();
													}}
												/>
											</div>
										</legend>

										<HoursDays
											scheduleData={schedules}
											setScheduleData={setSchedules}
											disabled={modalOption === "Watch"}
											isHours={isHours}
										/>
									</fieldset>
								</Grid.Column>

								<Grid.Column width={8}>
									<fieldset className={styles.fieldset}>
										<legend className={styles.legend}>Días Feriados</legend>
										<NewTable
											data={schedulesFeriados}
											columns={[
												{
													label: "Acciones",
													action: [
														{
															content: "edit",
															color: "#3f7ea3",
															onClick: "Edit",
															type: "icon",
															hidden: modalOption === "Watch",
															// isVisible: isVisibleAction,
														},
														{
															content: "trash",
															color: "#b43333",
															onClick: "Eraser",
															type: "icon",
															hidden: modalOption === "Watch",
															// isVisible: isVisibleActionD,
														},
													],
													addButton: true,
													dataPosition: "center",
													width: 1,
													hidden: modalOption === "Watch",
												},
												{
													label: "Id",
													key: "id",
													format: "string",
													dataPosition: "center",
													width: 1,
												},
												{
													label: "Título",
													key: "name",
													format: "string",
													width: 3,
												},
												{
													label: "Fecha",
													key: "date",
													dataPosition: "center",
													format: "date",
													width: 1,
												},
												{
													label: "Hora Inicio",
													key: "startHour",
													dataPosition: "center",
													format: "time",
													width: 1,
												},
												{
													label: "Hora Fin",
													key: "endHour",

													format: "time",
													width: 1,
												},
												{
													label: "Mensaje Fuera de Horario",
													key: "message.title",
													format: "string",
													dataPosition: "left",
													headerPosition: "left",
													width: 15,
												},
											]}
											defaultOrder={{ key: "id", dir: "desc" }}
											pageRows={15}
											handlerTable={handleApplyToAllAlwaysOpenFeriados}
											haveFooter
										/>
									</fieldset>
								</Grid.Column>
							</Grid.Row>
						)}
					</div>
				</div>
			</Modal.Content>
			<Modal.Actions className={styles.modalFooter}>
				<div>
					<Button className={styles.negativeButton} onClick={cleanChats}>
						Limpiar Chats
					</Button>
					<Button className={styles.negativeButton} onClick={cleanChatsh}>
						Limpiar Chats e Histórico
					</Button>
				</div>
				<div>
					{modalOption === "Watch" ? (
						<Button className={styles.negativeButton} onClick={onClose}>
							Cerrar
						</Button>
					) : (
						<Button className={styles.negativeButton} onClick={handleCancel}>
							Atrás
						</Button>
					)}

					{modalOption !== "Watch" && (
						<Button className={styles.positiveButton} onClick={handlerSaved}>
							{modalOption === "Add" ? "Guardar" : "Modificar"}
						</Button>
					)}
				</div>
			</Modal.Actions>
			{openAlertTimes && (
				<AlertTimes
					onClose={() => {
						setOpenAlertTimes(false);
					}}
					alertTimesHandler={alertTimesHandler}
					tableValue={alertItem}
					data={alerts}
				/>
			)}
			{openChanelCrud && (
				<ChanelCrud
					onClose={() => {
						setOpenChanelCrud(false);
					}}
					channelsHandler={channelsHandler}
					data={channelData}
					modalOption={modalOption}
					modalMode={channelData.modalOption}
					modalOptionCompany={modalOption}
					companyName={nameCompany}
				/>
			)}
			{openConfirmModalCompanyFields && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar Eliminar"
					fullContent={
						<>
							¿Está seguro que desea eliminar <span className={styles.focus}>{openDeleteCompanyFields.label}</span>? <br />
							Podría estar vinculado a contactos.
						</>
					}
					onConfirm={() => {
						deleteCompanyFields(openDeleteCompanyFields);
					}}
					onDismiss={() => {
						setOpenConfirmModalCompanyFields(false);
					}}
				/>
			)}
			{openChannelDConfirm && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Eliminar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar el Canal"
					focus={get(channelData, "label")}
					onConfirm={() => {
						channelDConfirmHandler(channelData);
					}}
					onDismiss={() => {
						setOpenChannelDConfirm(false);
					}}
				/>
			)}
			{openCleanChats && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Limpiar"
					buttonLabel="Limpiar Chats"
					content="Está seguro que desea Limpiar todos los Chats  de la compañía"
					focus={get(tableValue, "name")}
					onConfirm={() => {
						handleCleanChats();
					}}
					onDismiss={() => {
						setOpenCleanChats(false);
					}}
				/>
			)}
			{openCleanChatsh && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Limpiar"
					buttonLabel="Limpiar Chats"
					content="Está seguro que desea Limpiar todos los Chats e histórico de chats de la compañía"
					focus={get(tableValue, "name")}
					onConfirm={() => {
						handleCleanChatsH();
					}}
					onDismiss={() => {
						setOpenCleanChatsh(false);
					}}
				/>
			)}
			{openCancelConfirm && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Cerrar"
					fullContent="Tienes canales sin guardar. ¿Seguro que quieres salir y perder los cambios?"
					buttonLabel="Salir"
					onConfirm={() => {
						setOpenCancelConfirm(false);
						onClose();
					}}
					onDismiss={() => {
						setOpenCancelConfirm(false);
					}}
				/>
			)}

			{openSystemLogFieldCrud && (
				<SystemLogFieldCrud
					onClose={() => {
						setOpenSystemLogFieldCrud(false);
					}}
					systemLogFieldHandler={systemLogFieldHandler}
					data={systemLogFieldData}
					tableData={formData.companyFields}
					modalMode={systemLogFieldData.modalOption}
					modalOptionCompany={modalOption}
					companyId={tableValue.id}
				/>
			)}

			{openAddHoliDay && (
				<AddHoliDay
					open={openAddHoliDay}
					onClose={() => {
						setOpenAddHoliDay(false);
					}}
					onSave={handleSaveHoliDay}
					itemEditHoliDay={itemEditHoliDay}
					data={schedulesFeriados}
				/>
			)}

			{openAlertsDelete && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Eliminar"
					content="¿Estás seguro de querer eliminar este alerta"
					focus={alertsToDelete.name}
					buttonLabel="Eliminar"
					onConfirm={() => {
						renderAlertsDelete(alertsToDelete);
					}}
					onDismiss={() => {
						setOpenAlertsDelete(false);
					}}
				/>
			)}
		</Modal>
	);
};

function mapStateToProps({ user }) {
	return {
		userName: user.name,
	};
}
SettingCrud.propTypes = {
	tableValue: PropTypes.object,
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	modalCrud: PropTypes.string,
	refresh: PropTypes.func,
	currentCompanyId: PropTypes.number,
};
export default connect(mapStateToProps)(SettingCrud);
